import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { RecordModificationResponse } from "#root/utility/remote-data";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { currencyCollection, type CurrencyListItem, domicileCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

export default function ({ currencyId }): ReactNode {
  const navigate = useNavigate();
  const handleUpdate = useCallback(
    (data: RecordModificationResponse<CurrencyListItem>) => {
      if ("deleted" in data) {
        navigate("/admin/platform/reference/currency");
      } else if ("created" in data) {
        navigate(`/admin/platform/reference/currency/${data.created}`);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="Reference Data Platform - Edit Currency">
      <section>
        <h2>{currencyId === "new" ? "Create" : "Edit"} Currency</h2>
        <StandardEditor id={currencyId} collection={currencyCollection} onSave={handleUpdate} onDelete={handleUpdate}>
          <Fields.Set name="id">
            <label>Currency Id</label>
            <Fields.Integer required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="name">
            <label>Currency Name</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="code">
            <label>3 Letter Currency Code</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="issuer">
            <label>Issuing Domicile (Country) for Currency</label>
            <Fields.AutoComplete required collection={domicileCollection}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
